"use client";

import { useSwitchChain } from "wagmi";

import { isSupportedChainId } from "@/config/chains/helpers";

export type BasicChainStatus = "loading" | "supported" | "unsupported";

export function useBasicChainStatus(chainId: null | number): BasicChainStatus {
  const { isPending: wagmiIsSwitching } = useSwitchChain();

  if (wagmiIsSwitching) return "loading";
  if (!chainId || !isSupportedChainId(chainId)) return "unsupported";
  return "supported";
}
